<template>
	<div id="libraryDasboard" class="row no-bottom-margin grey lighten-5">
		<div class="loader-container" v-if="!ready">
				<div 
				class="preloader-wrapper small active">
				<div class="spinner-layer spinner-blue-only">
				<div class="circle-clipper left">
					<div class="circle"></div>
				</div><div class="gap-patch">
					<div class="circle"></div>
				</div><div class="circle-clipper right">
					<div class="circle"></div>
				</div>
				</div>
				</div>
			</div>
		<div id="eStateHolder" v-else-if="ready && items.length < 1">
			<empty-state
        :show-button="true">
				<template #header>{{timeOfDay}} {{user.name}}</template>
				<template #content>
					<div>
						You currently have no records in the list please select create a record below to begin
					</div>
				</template>
				<template #action>
          <router-link :to="{name:'new_item'}" class="btn-medium btn indigo accent-4 white-text">Create New Record</router-link>
				</template>
			</empty-state>
		</div>
			<div class="col s12  ">    
          <div class="col s12 l11 listing-view">
            <div class="col s12">
							<search-field @search="$_searchFilter($event)" class="left" style="width: 100%"/>
							<div class="clear"></div>
						</div>
						<div class="col textCaps">
							<select-field
									class="left "
									:currentValue="filterBy"
									:has-clear="true"
									:show-label="true"
									data-source="code"
									clear-prop="none"
									@update="filterBy = $event.values"
									:data-options="{
										icon: {
											active: false,
											value: 'sort'
										},
										v: true,
										type: 'select',
										label: 'Filter By Category',
									
										propName: 'status',
										options: ['none','Judgment','Book', 'Legislation', ]
									}"
								>
								<span></span>
							</select-field>
						</div>

						<div class="col textCaps">
							<select-field
									class="left "
									:currentValue="sortBy"
									:has-clear="true"
									clear-prop="Default"
									:show-label="true"
									data-source="code"
									@update="sortBy = $event.values"
									:data-options="{
										icon: {
											active: false,
											value: 'sort'
										},
										v: true,
										type: 'select',
										label: 'Sort By',
									
										propName: 'status',
										options: ['Default','Date Asc','Date Desc','Last Modified']
									}"
								>
								<span></span>
							</select-field>
						</div>
						<div class="col filters">
							<button 
								:class="gridView === 'grid'? 'grey lighten-3': 'transparent'"
								class="btn-floating  waves-effect z-depth-0" @click="gridView = 'grid'">
								<i class="material-icons grey-text text-darken-3">
									grid_view
								</i>
							</button>
							<button 
								:class="gridView === 'list'? 'grey lighten-3': 'transparent'"
								class="btn-floating  waves-effect z-depth-0" @click="gridView = 'list'">
								<i class="material-icons grey-text text-darken-3">
									list_alt
								</i>
							</button>
						</div>

						<div class="col input-field right right-align">
								<router-link  :to="{name:'new_item'}"  class="btn rounded waves-effect right white-text"> <i class="material-icons left white-text">launch</i>New Entry
								</router-link>
						</div>
						<div style="width:100%; height:1px; clear:both;"></div>
						<div>
						<div v-if="searchFilter === ''"  class="row flex wrap-items" style="padding: 12px;">
							<div class="col" :class="gridView === 'grid' ? 's12 m4 ;4' : 's12 m12 l12'" v-for="item in mappedItems" :key="item.id">
								<library-card :grid-view="gridView" @delete="$_deleteEntry(item)" :data-content="item" />
							</div>
								<infinite-loading v-if="!fetching && shouldFetch" @infinite="getEntries(true)"> </infinite-loading> 
						</div>
						<div v-else  class="row flex wrap-items" style="padding: 12px;">
							<div class="col" :class="gridView ===  'grid'? 's12 m4 ;4' : 's12 m12 l12'" v-for="item in searchResultsX" :key="item.id">
								<library-card :grid-view="gridView" @delete="$_deleteEntry(item)" :data-content="item" />
						</div>
							<infinite-loading v-if="!fetching && shouldFetch" @infinite="getEntries(true)"> </infinite-loading> 
					</div>	
							<!--  v-if="!fetching && shouldFetch" @infinite="getEntries(true)" -->
					
						</div>
            <div class="clear"></div>
          </div>
			</div>
	
		<div class="pickers" id="pickerContainer">
			
		</div>
		<!-- diglog  Modal -->
    <div class="dialog" ref="dialogComponent"></div>
    <!-- block list Modal -->
		<router-view />
		<file-viewer v-if="fileInView" file-in-view="fileInView" @complete="fileInView= false"/>
	</div>
</template>
<script>
import core from '@/functions'

export const debounce = (func, delay) => {
  let inDebounce
  return function () {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() =>
      func.apply(context, args), delay)
  }
}
import moment from 'moment'
import fileViewer from '@/components/fileViewer.component'
import LibraryCard from '@/components/library/LibraryCard.component'
import InfiniteLoading from 'vue-infinite-loading'
import dialogComponent from '@/components/dialog.component'
import contentService from '@/services/contentService'
import searchField from '@/components/searchField.component'
import estate from '@/assets/estate.svg'
import Vue from 'vue'
import { mapState } from 'vuex'
import selectField from "@/components/editing/selectField.component"
import emptyState from '@/components/emptyState.component'
import Fuse from 'fuse.js'
export default {
	name: 'library',
	components: {
		emptyState,
		selectField,
		InfiniteLoading,
		LibraryCard,
		fileViewer,
		searchField,
		// eslint-disable-next-line vue/no-unused-components
		dialogComponent,
	},
	data () {
		return {
			estate,
			fileInView: false,
			searchResults:[],
			sortBy:'Default',
			gridView: 'grid',
			searchEngine: null,
			searchEngineConfig:{
        useExtendedSearch: true,
        shouldSort: true,
				//findAllMatches: true,
				ignoreLocation: true,
				distance:200,
        keys: [
          'title.rendered',
					'acf.entry_type',
					'acf.sub_title',
					'acf.legislation.notes',
					'acf.book.author',
					'acf.book.isbn',
					'acf.book.publisher',
					'acf.book.year',
					'acf.book.publisher',
					'acf.Judgments.date_delivered',
					'acf.Judgments.claim_no',
					
        ]
			},
			filterBy:'none',
			searchFilter: '',
      items: [],
			ready:false,
			fetching: false,
			shouldFetch: false,
			pagination: {
        page: 1,
        per: 100,
				totalItems: 0,
				totalPages: 0,
      }
		};
	},
	mounted() {
    this.getEntries()
	},
	watch:{
		searchResults: function(nV) {
			if(nV.length < 2 && parseInt(this.pagination.totalItems) !== this.items.length) this.getEntries(true)
		},
		mappedItems: function(nV) {
			if(nV.length < 2 && parseInt(this.pagination.totalItems) !== this.items.length) this.getEntries(true)
		},
		searchEngine: function(nV, oV) {
	//	console.log(nV)
			if(nV && oV !== null && this.searchFilter !== '') this.$_searchQuery(this.searchFilter)
		}
	},
	computed: {
		...mapState({
			user: state => state.user,
			authUser: state => state.authUser,
			users:state=> state.record.users,
			companies:state=> state.record.companies
		}),
		searchResultsX:{
			get () {
				let arr = this.filterBy === 'none'
				? this.searchResults
				: this.searchResults.filter(a => a.acf.entry_type === this.filterBy)
					return arr
			}
		},
		currentRoute:{
			get(){
				return this.$route.name
			}
		},
		mappedItems : {
			get () {
			let arr = this.filterBy === 'none'
			? this.items 
			: this.items.filter(a => a.acf.entry_type === this.filterBy)

	/* 'Date Asc','Date Desc','Modified' */
				if(this.sortBy === 'Date Asc')
					return arr.sort((a, b) => moment(new Date(b.date)).diff(moment(new Date(a.date))))
				if(this.sortBy === 'Date Desc')
					return arr.sort((a, b) => moment(new Date(a.date)).diff(moment(new Date(b.date))))
				if(this.sortBy === 'Last Modified')
						return arr.sort((a, b) => moment(new Date(b.modified)).diff(moment(new Date(a.modified))))
					else return arr
				/* 		.filter(b => core.createFieldsText([b.acf.case_name, b.title.rendered, b.acf.name, b.acf.appearances, b.acf.status]).replace(/  +/g, ' ')
						.toLowerCase()
						.includes(this.searchFilter.replace(/  +/g, ' ').toLowerCase())) */
						
			}
		},
		timeOfDay: function() {
			let today = new Date();
			let curHr = today.getHours();
			if (curHr < 12) {
				return "Good Morning";
			} else if (curHr < 18) {
				return "Good Afternoon";
			} else {
				return "Good Evening";
			}
		},
	},
	methods: {
		$_searchFilter($event) {
			this.searchFilter = $event
			this.$_searchQuery($event)
		},
		$_searchQuery:debounce(function(e){
		//	window.console.log(e)
			const search = async ()=> {return this.searchEngine.search(e)}
			search().then(x => {
					this.searchResults = x 
		///		window.console.log(x)
			})
		}, 900),
		statusColor(s){
		return s === 'not-started'
				? 'indigo accent-4'
				: s === 'on-hold'
					? 'yellow darken-2 brown-text'
					: s === 'pending'
						? 'yellow darken-2 grey-text text-darken-3'
						: s === 'complete'
							? 'green accent-4'
							: 'red white-text'
		},
    getEntriesX (g) {
    let query = {per_page: this.pagination.per, page: g ? this.pagination.page + 1 : 1}
		contentService.getLibraryEntries({q:query})
        .then(res => {
          this.items = res.data 
          this.ready = true
					this.searchEngine = new Fuse(this.items, this.searchEngineConfig)
        })
    },
    getEntries (g) {
		this.fetching = true
    let query = {per_page: this.pagination.per, page: g ? this.pagination.page + 1 : 1}
      contentService.getLibraryEntries({q:query})
        .then(res => {
					this.pagination.totalItems = res.headers['x-wp-total']
					this.pagination.totalPages = res.headers['x-wp-totalpages']
          ///this.items = res.data 
					this.shouldFetch = false
					this.fetching = false
					this.pagination.page = query.page
				this.items = [...this.items, ...res.data]
				
				setTimeout(() => {
						this.searchEngine = new Fuse(this.items, this.searchEngineConfig)	
				}, 100);

				if (!this.ready) this.ready = true 
				if (parseInt(this.pagination.totalPages) > 1 && this.pagination.page !== parseInt(this.pagination.totalPages)) {
        setTimeout(() => {
          this.shouldFetch = true
        }, 1000)
      }    
        })
    },
		dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "context"
        },
        domProps: {
          innerHTML: data.message
        }
      });

      instance.$slots.default = [link];
      instance.$slots["title"] = [data.title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
		$_deleteEntry(item){
		let data = {
				title:'Delete Entry',
        message: "Are you sure you want to delete this "+item.acf.entry_type,
        buttons: [
          {
            id: 0,
            value: "cancel",
            action: () => {},
            close: true
          },
   
          {
            id: 2,
            value: "Delete",
            action: () => {
						contentService.deleteEntry(item.id)
							.then(res=>{
								if(res.data.id){
						//			this.$store.commit('DELETE_RECORD', id)
								let record = 	this.items.findIndex(x => x.id === item.id)
								this.items.splice(record, 1)
								this.$forceUpdate()
								core.toastMessage('Successfully deleted record')
								}
							})
            },
            close: true
          }
        ]
      };
			this.dialogMessages(data);
		},
	}
};
</script>
<style scoped lang="scss">
div#libraryDasboard {
	min-height: 80vh;
	position: relative;
	@media screen and (min-width: 1024px) {
		width: 100%;
		padding-left: 300px;
	}
	#eStateHolder {
		left: 50%;
		top: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		@media screen and (min-width: 1024px) {
			transform: translate(calc(-50% + 150px), -50%);
		}
	}
	.title-section {
		font-size: 24px;
		line-height: 1.5;
		margin: 12px 0px 12px 0px;
	}
	.page-meta {
		font-size: 24px; 
		line-height: 1.3;
		margin: .75rem 0;
	}
	.clearbtn {
    position: absolute;
    right: 9px;
    top: 16px;
    cursor: pointer;
			i {
        font-size: 18px;
      }
  }
	
	.tsc {
		position: relative;
		&::before {
			content: "search";
			font-family: "Material Icons";
			font-size: 21px;
			position: absolute;
			top: 10px;
			color: #8f8f8f;
			left: 12px;
		}
	}
	.circle-tar {
		border-radius:50%;
		width:50px;
		height:50px;
	}
button.btn.cs-btn {
    padding: 0px 4px;
    height: 30px;
    line-height: 29px;
    margin-right: 5px;
}
.loader-container {
		position: fixed;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
			@media screen and (min-width:1024px){
				left:calc(50% + 300px);
				transform:translate(calc(-50% - 250px),-50%);
			}
	}
  .listing-view {
    margin-top:24px;
  }
	.badge {
		text-transform: capitalize;
	}
}
</style>
<style lang="scss">
	.textCaps, .textCaps input.select-dropdown.dropdown-trigger {
		text-transform: capitalize !important;
	}
	.filters {
		padding-top: 12px !important;
	}
</style>